import FormLabel from '@material-ui/core/FormLabel';

export default FormLabel;
